<template>
  <Dashboard>
    <p class="text-text-secondary">{{ $t('common.loading') }}</p>
  </Dashboard>
</template>

<script setup>
// The sidebar entry: a manager goes to the control room, a viewer to their night, everyone else
// to the live LAN parties.
import { onBeforeUnmount } from 'vue';
import axios from 'axios';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
// eslint-disable-next-line import-x/extensions
import { useAuth } from '@websanova/vue-auth/src/v3.js';
import Dashboard from '../components/layouts/DashboardLayout.vue';

const router = useRouter();
const store = useStore();
const auth = useAuth();
let unmounted = false;

function go(target) {
  if (!unmounted) router.replace(target);
}

// /matchmaking sends a LAN-only player here, so sending them back would loop.
function fallback() {
  return auth.user()?.matchmaking_lan_only ? '/' : { name: 'MatchmakingLanPage' };
}

axios.get('/matchmaking/parties').then(({ data }) => {
  store.commit('setMatchmakingContext', data);
  if (data.creator) return go({ name: 'LanControlRoomPage', params: { slug: data.creator.slug } });
  if (data.lan_party) return go({ name: 'LanPartyPage', params: { slug: data.lan_party.creator } });
  return go(fallback());
}).catch(() => go(fallback()));

onBeforeUnmount(() => { unmounted = true; });
</script>
